import "core-js/modules/es.array.reverse.js";
var _class, _descriptor, _BingMapsCatalogItem;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { computed, observable, makeObservable, runInAction } from "mobx";
import Credit from "terriajs-cesium/Source/Core/Credit";
import BingMapsImageryProvider from "terriajs-cesium/Source/Scene/BingMapsImageryProvider";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import BingMapsCatalogItemTraits from "../../../Traits/TraitsClasses/BingMapsCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
let BingMapsCatalogItem = (_class = (_BingMapsCatalogItem = class BingMapsCatalogItem extends MappableMixin(CatalogMemberMixin(CreateModel(BingMapsCatalogItemTraits))) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "_imageryProvider", _descriptor, this);
    makeObservable(this);
  }
  get type() {
    return BingMapsCatalogItem.type;
  }
  async forceLoadMapItems() {
    const provider = await BingMapsImageryProvider.fromUrl("//dev.virtualearth.net", {
      mapStyle: this.mapStyle,
      key: this.key,
      culture: this.culture
    });
    runInAction(() => {
      this._imageryProvider = provider;
    });
  }
  get mapItems() {
    const imageryProvider = this._createImageryProvider();
    if (imageryProvider === undefined) return [];
    return [{
      imageryProvider,
      show: this.show,
      alpha: this.opacity,
      clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
    }];
  }
  _createImageryProvider() {
    const result = this._imageryProvider;
    if (result === undefined) return result;
    if (this.attribution) {
      result._credit = this.attribution;
    } else {
      // open in a new window
      result._credit = new Credit('<a href="http://www.bing.com" target="_blank">Bing</a>');
    }
    return result;
  }
}, _defineProperty(_BingMapsCatalogItem, "type", "bing-maps"), _BingMapsCatalogItem), _descriptor = _applyDecoratedDescriptor(_class.prototype, "_imageryProvider", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mapItems"), _class.prototype), _class);
export { BingMapsCatalogItem as default };